(() => {
  const setup = (root = document) => {
    root.querySelectorAll('.sh-back-to-top').forEach((link) => {
      const existing = document.body.querySelector('.sh-back-to-top[data-sh-fixed]');
      if (existing && existing !== link) { link.remove(); return; }
      if (link.dataset.shFixed) return;
      link.dataset.shFixed = 'true';
      // A body child stays fixed to the viewport even if theme wrappers transform.
      document.body.appendChild(link);
      link.addEventListener('click', (event) => {
        event.preventDefault();
        window.scrollTo({top:0,left:0,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      });
    });
    root.querySelectorAll('.sh-footer__group').forEach((details) => {
      if (details.dataset.shReady) return;
      details.dataset.shReady = 'true';
      const summary = details.querySelector('summary');
      const panel = details.querySelector('.sh-footer__panel');
      let animation;
      let expanded = details.open;
      // Native <details> remains fully functional when scripting is unavailable.
      if (window.matchMedia('(max-width: 800px)').matches) details.open = expanded = false;
      summary.addEventListener('click', (event) => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !panel.animate) return;
        event.preventDefault();
        const from = details.open ? panel.getBoundingClientRect().height : 0;
        expanded = !expanded;
        animation?.cancel();
        details.open = true;
        const to = expanded ? panel.scrollHeight : 0;
        panel.style.overflow = 'hidden';
        animation = panel.animate([{height:`${from}px`,opacity:expanded?0.45:1},{height:`${to}px`,opacity:expanded?1:0}],{duration:300,easing:'cubic-bezier(.2,.7,.2,1)'});
        animation.onfinish = () => {details.open = expanded; panel.style.overflow = ''; animation = null;};
      });
      details.addEventListener('toggle', () => { if (!animation) expanded = details.open; });
    });
  };
  setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
